import { Resolve } from "@angular/router";
import { Injectable } from "@angular/core";
import { of } from "rxjs";

@Injectable()
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class DataResolver implements Resolve<any> {
    public resolve() {
        return of({ res: "I am data" });
    }
}

/**
 * An array of services to resolve routes with data.
 */
export const APP_RESOLVER_PROVIDERS = [
    DataResolver
];
